<template>
  <div id="index">
    <div class="container">
      <!-- 顶部Banner -->
      <!-- <div class="banner">电器专场</div> -->
      <div class="slider-banner banner">
      <swiper :options="swiperOption" v-if="banner.length > 0" ref="mySwiper" >
        <swiper-slide v-for="(item, i) in banner" :key="i">
          <router-link :to="item.wap_url">
            <img :src="item.pic" />
          </router-link>
        </swiper-slide>
        <div class="swiper-pagination paginationBanner" slot="pagination"></div>
      </swiper>
    </div>
      <!-- 品类导航 -->
      <div class="category-nav">
        <div class="category-item" v-for="category in categories" :key="category">
          {{ category }}
        </div>
      </div>
      
      <!-- 品牌专区 -->
      <div class="brand-section" style="display: flex;">
        <div class="brand-area haier-area" style="width: 50%;height: 240px;">
          <div class="brand-title">海尔及海尔兄弟品牌专区</div>
        </div>
        <div class="brand-area" style="width: 50%;height: 240px;">
          <div class="brand-title brand-area miniso-area" style="height: 115px;width: 100%;" >名创优品</div>
          <div class="brand-title brand-area miniso-area" style="height: 115px;width: 100%;">品牌专区</div>
        </div>
      </div>
      
      <!-- 蔬果园区域 -->
      <!-- <div class="brand-area" style="background-color: #f0fff3; margin-bottom: 10px;">
        <div class="brand-title">蔬果园</div>
        <div class="brand-subtitle">新鲜直达</div>
      </div> -->
      
      <!-- 产品行 -->
      <div class="product-row">
        <div class="brand-area panasonic-area">
          <div class="brand-title">松下</div>
          <div class="brand-subtitle">品质家电</div>
        </div>
        <div class="brand-area perfect-diary-area">
          <div class="brand-title">完美日记</div>
          <div class="brand-subtitle">美妆优选</div>
        </div>
      </div>
      
      <!-- 每日特惠 -->
      <div class="daily-deals" style="display: flex;width: 100%;">
        <div class="deals-header">
            <img src="@/assets/images/tehui.jpg" style="width: 50px; height: 50px;"  alt="img" />
            <div style="color:#ccc;">
                <span class="num" style="font-size: 12px;">每日特惠111</span><br>
                <span class="nums" style="font-size: 12px;">10点开启</span>
            </div>
        </div>
        <div class="deals-grid categories-scroll" style="width: 80%;">
          <div class="deal-item" v-for="(item,n) in goods" :key="n">
            <img :src="item.url" style="width: 50px; height: 50px;"  alt="img" />
            <div style="color:#ccc;">
                <span class="num" style="color: red;">￥:{{item.price}}</span>
            </div>
          </div>
        </div>

        
      </div>
      

      <div class="productList" style="background:#f5f5f5;" ref="container">
        <div class="list acea-row row-between-wrapper" style="margin-top:0.2rem !important;" :class="Switch === true ? '' : 'on'" ref="container">
          <div @click="goDetail(item)" v-for="(item, index) in info.bastList" :key="index" class="item" style="width: 48%;" :class="Switch === true ? '' : 'on'" :title="item.store_name">
            <div class="pictrue" :class="Switch === true ? '' : 'on'">
              <img style="position:absolute;right: 0;" :src="item.image" :class="Switch === true ? '' : 'on'" />
              <div class="icon-mianxi">
                <span>{{ item.fenqi_num }}期</span>
                <span>免息</span>
              </div>
              <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'" v-if="item.activity && item.activity.type === '1'">秒杀</span>
              <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'" v-if="item.activity && item.activity.type === '2'">砍价</span>
              <span class="pictrue_log_class" :class="Switch === true ? 'pictrue_log_big' : 'pictrue_log'" v-if="item.activity && item.activity.type === '3'">拼团</span>
            </div>
            <div class="text" :class="Switch === true ? '' : 'on'">
              <div class="name store-name">{{ item.store_name }}</div>
              <div class="money font-color-red" :class="Switch === true ? '' : 'on'">
                ￥<span class="num">{{ item.fenqi_price }}</span>
                <span style="color: black; font-weight: normal; font-size: 0.26rem;"> /期起</span>
              </div>
              <div style="font-size:0.3rem;color:#ccc;" :class="Switch === true ? '' : 'on'">
                ￥<span class="num">{{ item.price }}</span>
              </div>
            </div>
          </div>
        </div>
        <div style="height:1.5rem;"></div>
      </div>



      <!-- 底部品类导航 -->
      <div class="category-nav">
        <div class="category-item" v-for="category in categories" :key="category">
          {{ category }}
        </div>
      </div>
    </div>
  </div>

  
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import "@assets/css/swiper.min.css";
import GoodList from "@components/GoodList";
import PromotionGood from "@components/PromotionGood";
import CouponWindow from "@components/CouponWindow";
import { getHomeData, getShare, follow } from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { goShopDetail } from "@libs/order";
import { orderPayStatus } from "@api/order";
import Vue from "vue";
import { Popup, Checkbox, CheckboxGroup } from "vant";

Vue.use(Popup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);

const HAS_COUPON_WINDOW = "has_coupon_window";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";
let vm = null;
export default {
  name: "Index",
  components: {
    Swiper,
    SwiperSlide,
    GoodList,
    PromotionGood,
    CouponWindow,
  },
  props: {},
  data: function() {
    return {
      id: "",
      categories: ['家用电器', '美妆护肤', '家清日用', '运动户外', '家居日用'],
      goods:[
        {
            'price':'12.5/期起',
            'url':'https://www.giftoceanmall.com/uploads/attach/2025/09/20250928/07c9388af80c16766af7a9d79885daf5.jpg'
        },
        {
            'price':'12.5/期起',
            'url':'https://www.giftoceanmall.com/uploads/attach/2025/09/20250928/07c9388af80c16766af7a9d79885daf5.jpg'
        },
        {
            'price':'12.5/期起',
            'url':'https://www.giftoceanmall.com/uploads/attach/2025/09/20250928/07c9388af80c16766af7a9d79885daf5.jpg'
        },
        {
            'price':'12.5/期起',
            'url':'https://www.giftoceanmall.com/uploads/attach/2025/09/20250928/07c9388af80c16766af7a9d79885daf5.jpg'
        },
        {
            'price':'12.5/期起',
            'url':'https://www.giftoceanmall.com/uploads/attach/2025/09/20250928/07c9388af80c16766af7a9d79885daf5.jpg'
        },
        {
            'price':'12.5/期起',
            'url':'https://www.giftoceanmall.com/uploads/attach/2025/09/20250928/07c9388af80c16766af7a9d79885daf5.jpg'
        },
        {
            'price':'12.5/期起',
            'url':'https://www.giftoceanmall.com/uploads/attach/2025/09/20250928/07c9388af80c16766af7a9d79885daf5.jpg'
        },
        {
            'price':'12.5/期起',
            'url':'https://www.giftoceanmall.com/uploads/attach/2025/09/20250928/07c9388af80c16766af7a9d79885daf5.jpg'
        },
      ],
      Switch: true,
      checked: false,
      show: false,
      newGoodsBananr: "",
      isWeixin: isWeixin(),
      followUrl: "",
      subscribe: false,
      followHid: false,
      followCode: false,
      showCoupon: false,
      logoUrl: "",
      banner: [],
      menus: [],
      roll: [],
      activity: [],
      activityOne: {},
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: [],
      },
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      categorySwiperOption: {
        pagination: {
          el: ".categoryPaginationBanner",
          clickable: true,
        },
        loop: false,
      },
      swiperOption: {
        spaceBetween: 10,
        pagination: {
          el: ".paginationBanner",
          clickable: true,
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000,
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        on: {
          tap: function() {
            const realIndex = this.realIndex;
            vm.goUrl(realIndex);
          },
        },
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000,
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true,
      },
      swiperBoutique: {
        pagination: {
          el: ".paginationBoutique",
          clickable: true,
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000,
        },
        loop: true,
        speed: 1500,
        observer: true,
        observeParents: true,
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true,
      },
      mapKey: "",
    };
  },
  computed: {
    groupedList() {
      // 每页8个，分组展示
      const itemsPerPage = 8;
      const result = [];
      for (let i = 0; i < this.info.fastList.length; i += itemsPerPage) {
        result.push(this.info.fastList.slice(i, i + itemsPerPage));
      }
      return result;
    },
  },
  created() {
    vm = this;
  },
  mounted: function() {
    // const datas = {
    //   token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ3d3cuZ2lmdG9jZWFubWFsbC5jb20iLCJhdWQiOiJ3d3cuZ2lmdG9jZWFubWFsbC5jb20iLCJpYXQiOjE3NTQ5MTE3MjAsIm5iZiI6MTc1NDkxMTcyMCwiZXhwIjoxNzU0OTIyNTIwLCJqdGkiOnsiaWQiOjIsInR5cGUiOiJ1c2VyIn19.-vZzvqb3nrMGbB_2EmbIzsRjDSpVXkC6yTI0E08KZUE",
    //   expires_time: "2025-08-12 18:12:15",
    // };
    // this.$store.commit("LOGIN", datas);

    this.getFollow();
    let that = this;
    that.id = this.$route.params.id;
    getHomeData().then((res) => {
      that.mapKey = res.data.tengxun_map_key;
      cookie.set(MAPKEY, that.mapKey);
      that.logoUrl = res.data.logoUrl;
      that.newGoodsBananr = res.data.newGoodsBananr;
      //console.log(res.data.banner);
      that.$set(that, "banner", res.data.banner);
      that.$set(that, "menus", res.data.menus);
      that.$set(that, "roll", res.data.roll);
      that.$set(that, "activity", res.data.activity);
      if (res.data.activity.length) {
        var activityOne = res.data.activity.shift();
        that.$set(that, "activityOne", activityOne);
      }
      that.$set(that, "info", res.data.info);
      that.$set(that, "likeInfo", res.data.likeInfo);
      that.$set(that, "lovely", res.data.lovely.length ? res.data.lovely[0] : {});
      that.$set(that, "benefit", res.data.benefit);
      that.$set(that, "couponList", res.data.couponList);
      that.subscribe = res.data.subscribe;
      if (!that.subscribe && that.followUrl) {
        setTimeout(function() {
          that.followHid = true;
        }, 200);
      } else {
        that.followHid = false;
      }
      if (res.data.site_name) document.title = res.data.site_name;
      that.setOpenShare();
      this.showCoupon = !cookie.has(HAS_COUPON_WINDOW) && res.data.couponList.some((coupon) => coupon.is_use);
      if (!cookie.get(LATITUDE) && !cookie.get(LONGITUDE)) this.getWXLocation();
    });

    //买单吧返回首页
    // if (that.id != undefined) {
    //   that.payStatus();
    // }
  },
  methods: {
    handleShare() {
      if (typeof srsCallNative === "function") {
        let parameters = {
          content: [
            {
              action: "share",
              title: "分享",
              para: {
                channel: "WX,Wechant",
                desc: "分享描述",
                imageUrl: "分享的图片地址",
                pageUrl: "分享的页面URL",
                title: "分享的标题",
              },
            },
          ],
        };

        window.hycb = () => {};
        srsCallNative("JSNative", parameters, "hycb");
      }
    },
    //取消（关闭浏览器）
    handleOff() {
      setTimeout(function() {
        window.location.href = "mdb://closeWebPage";
      }, 200);
    },
    //继续访问
    handleGo() {
      let value = {
        status: true,
        expires: Date.now() + 86400000,
      };
      if (this.checked == true) {
        value.expires = "";
        cookie.set("prompt_check", value);
      } else {
        cookie.set("prompt_check", value);
      }
      this.show = false;
    },

    // 轮播图跳转
    goUrl(index) {
      let url = this.banner[index].wap_url;
      let newStr = url.indexOf("http") === 0;
      if (newStr) {
        window.location.href = url;
      } else {
        this.$router.push({
          path: url,
        });
      }
    },
    // 商品详情跳转
    goDetail(item) {
      goShopDetail(item).then(() => {
        this.$router.push({ path: "/detail/" + item.id });
      });
    },
    getWXLocation() {
      if (isWeixin()) {
        wxShowLocation();
      } else {
        if (!this.mapKey) console.log("暂无法使用查看地图，请配置您的腾讯地图key");
        let loc;
        // if (_this.$route.params.mapKey) _this.locationShow = true;
        //监听定位组件的message事件
        window.addEventListener(
          "message",
          function(event) {
            loc = event.data; // 接收位置信息 LONGITUDE
            console.log("location", loc);
            if (loc && loc.module == "geolocation") {
              cookie.set(LATITUDE, loc.lat);
              cookie.set(LONGITUDE, loc.lng);
            } else {
              cookie.remove(LATITUDE);
              cookie.remove(LONGITUDE);
              //定位组件在定位失败后，也会触发message, event.data为null
              console.log("定位失败");
            }
          },
          false
        );
      }
    },
    closeFollow() {
      this.followHid = false;
    },
    followTap() {
      this.followCode = true;
      this.followHid = false;
    },
    closeFollowCode() {
      this.followCode = false;
      this.followHid = true;
    },
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    getFollow() {
      follow()
        .then((res) => {
          this.followUrl = res.data.path;
        })
        .catch(() => {});
    },
    setOpenShare() {
      if (isWeixin()) {
        getShare().then((res) => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img,
          };
          openShareAll(configAppMessage);
        });
      }
    },
    //更新订单支付状态
    payStatus() {
      orderPayStatus(this.id).then((res) => {
        console.log(res);
      });
    },
  },
};
    
</script>
<style>
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
    
    body {
      font-family: "PingFang SC", "Helvetica Neue", Arial, sans-serif;
      background-color: #f5f5f5;
      color: #333;
      max-width: 750px;
      margin: 0 auto;
    }
    
    .container {
      background-color: #fff;
      padding: 10px;
    }
    
    .banner {
      background: linear-gradient(135deg, #ff7e5f, #feb47b);
      color: white;
      text-align: center;
      padding: 15px;
      border-radius: 8px;
      margin-bottom: 10px;
      font-size: 18px;
      font-weight: bold;
    }
    
    .category-nav {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }
    
    .category-item {
      flex: 1;
      text-align: center;
      padding: 8px 5px;
      font-size: 14px;
      border-radius: 4px;
      background-color: #f9f9f9;
      margin: 0 3px;
    }
    
    .brand-section {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      margin-bottom: 10px;
    }
    
    .brand-area {
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-height: 100px;
    }
    
    .haier-area {
      background-color: #e6f7ff;
      grid-column: 1 / 2;
    }
    
    .miniso-area {
      background-color: #fff2e8;
      grid-column: 2 / 3;
    }
    
    .brand-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 5px;
    }
    
    .brand-subtitle {
      font-size: 12px;
      color: #666;
    }
    
    .product-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      margin-bottom: 10px;
    }
    
    .panasonic-area {
      background-color: #f6ffed;
      grid-column: 1 / 2;
    }
    
    .perfect-diary-area {
      background-color: #fff0f6;
      grid-column: 2 / 3;
    }
    
    .daily-deals {
      margin-bottom: 10px;
      height: 105px;
    }
    
    .deals-header {
      background-color: #ff4d4f;
      color: white;
      padding: 10px;
      border-radius: 8px 8px 0 0;
      font-size: 16px;
      font-weight: bold;
    }
    
    .deals-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 1px;
      background-color: #ddd;
    }
    
    .deal-item {
      background-color: white;
      padding: 10px 10px 5px;
      text-align: center;
      font-size: 12px;
    }
    
    .deal-item:nth-child(odd) {
      background-color: #f9f9f9;
    }

    .categories-scroll {
        display: flex;
        overflow-x: auto;
        scroll-behavior: smooth;
        scrollbar-width: none; /* Firefox */
    }
        
    .categories-scroll::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera */
    }
    
    
  </style>  